import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Table } from "primeng/table";
import { TableModule } from "primeng/table";
import { UserWalletService } from "src/app/services/userWallet.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { ConfirmationService, MessageService } from "primeng/api";
import { BannerService } from 'src/app/services/banner.service';
import { UserService } from 'src/app/services/user.service';
const frontEnd = environment.frontEnd;
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { CustomValidators } from "ng2-validation";
import { WindowRefService } from "src/app/services/window-ref.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";

@Component({
  selector: 'app-refer-and-earn',
  templateUrl: './refer-and-earn.component.html',
  styleUrls: ['./refer-and-earn.component.scss'],
  providers: [ConfirmationService, MessageService, WindowRefService],
  
})
export class UserReferAndEarnComponent implements OnInit {
  public bannerImageList: any = [];
  public bannerList: any = [];
  public shareurl;
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public walletlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  public totalReferee = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  downloadFlg: boolean;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  addCashmodal: boolean = false;
  showThankyouModal: boolean = false;
  addCoinmodal: boolean = false;
  totalAvailableCash;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  addCashForm: FormGroup;
  addCoinForm: FormGroup;
  submitted = false;
  coinsubmitted = false;
  public item;
  public referralcode;
  public profileDetails;
  presentKyaData: boolean;
  @ViewChild('inputRef') inputRef: ElementRef;
  @ViewChild("dt", { static: false }) public dt: Table;
  constructor(
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private userWalletService: UserWalletService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private winRef: WindowRefService,
    private router: Router,
    private formBuilder: FormBuilder,
    private bannerService: BannerService,
    private userService: UserService,
    private walletpaymentService: WalletpaymentService
  ) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {
      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  ngOnInit() {
    this.getBanner();
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
    }
    this.addCashForm = this.formBuilder.group({
      amount: ["", [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
    });
    this.addCoinForm = this.formBuilder.group({
      amount: ["", [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
    });
    this.getUserDetails(this.userId);
    this.  loadAcademyReferrerList(this.userId)
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.addCashForm.controls;
  }
  get f1() {
    return this.addCoinForm.controls;
  }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).subscribe(
      data => {
        this.item = data;
    
        if (this.item) {
          this.profileDetails = this.item;
          this.referralcode = this.item.referral_code;
          const heading = 'Hey there,';
          const subheading = "I've been using TPL App and it's been amazing! 👌 ";
          const titleparagraph = "If you're interested in trying it out, I have a referral code that can give you *1000 TPL Coins* when you sign up. ";
          const ReferralCode = "Here's my referral code: *"+ this.referralcode+"*\n";
          const referralCodeLink = "\nClick to Signup: "+ frontEnd.domain + "/sign-up?ref=" + this.referralcode;
          const ReferralCodeinfo = "\nLet me know if you have any questions or need more info. ";
      
          const currentPageLink = window.location.href;
          const pagelink = '*' + currentPageLink + '*';
      
          // const org = 'For inquiries, contact ' + this.academyName + ' at ' + this.organizercontactnumber + '.';
          const text = 'Lets hit the court together and make this tournament an unforgettable experience! 🎾🏆';
          const seeyou = 'Cheers!';
          const phoneNumber = '1234567890'; // Replace with the recipient's phone number
      
          const siteIconUrl = 'https://www.tplsport.com/favicon.ico'; // Replace with your site's icon URL
      
          // Construct the WhatsApp sharing URL
          const message = encodeURIComponent(heading + '\n' + '\n' + subheading + '\n' + '\n' + titleparagraph + '\n' + '\n' + ReferralCode + referralCodeLink + '\n' + '\n' + ReferralCodeinfo + '\n' + '\n' + seeyou + '\n' + '\n' + '\n');
          
          this.shareurl = `https://api.whatsapp.com/send?text=${message}&link=${currentPageLink}&image=${siteIconUrl}`;          
          var query = "?filterDisable=false&filterByuserId=" + userId;
          this.userService.getUserKycDetailsList(query).subscribe(
            (data) => {
              this.totalRecords = data.totalCount;
              if (this.totalRecords < 1) {
                this.presentKyaData = false
              } else {
                this.presentKyaData = true
              }
            })
        }
        
      }, err => {
      });
  }

  loadWalletHistory(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query =
      "?filterByDisable=false&filterByUserid=" +
      this.userId +
      "&sortBy=created_at&orderBy=DESC";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    // at the time of download hide pagination option
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.userWalletService.getUserWalletList(query).subscribe(
      (data) => {
        this.loading = false;
        this.walletlist = data.data.items;
        this.totalCash = data.data.totalCash;
        this.totalDeductedCash = data.data.totalDeductedCash;
        this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        this.totalCoins = data.data.totalCoins;
        this.totalDeductedCoin = data.data.totalDeductedCoin;
        this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.totalRecords = data.data.totalCount;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  addCash() {
    this.addCoinmodal = false;
    this.addCashmodal = true;
  }

  onCashSubmit() {
    this.submitted = true;
    if (this.addCashForm.invalid) {
      return;
    }
    var addCashData = this.addCashForm.value;
    addCashData["userId"] = this.userId;    
    if (addCashData['amount'] > 0) {
      this.addCashmodal = false;
      addCashData = JSON.stringify(addCashData, null, 4);
      const amt = addCashData["amount"];
      console.log(amt);
      this.walletpaymentService
        .addWalletPayment(addCashData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Cash to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: "CASH",
              amount: this.addCashForm.value.amount,
            };
            // call your backend api to verify payment signature & capture transaction
            this.walletpaymentService
              .verifyWalletpayment(verifyPaymentData)
              .subscribe((paymentdata) => {
                window.scroll(0, 0);
                this.showThankyouModal = true;
                this.addCashForm.reset();
                this.addCoinForm.reset();
                let currentUrl = this.router.url;
                this.router
                  .navigateByUrl("/", { skipLocationChange: true })
                  .then(() => {
                    this.router.navigate([currentUrl]);
                  });
                window.location.reload();
              });
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
            console.log("Transaction cancelled.");
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }
  cashclose() {
    this.submitted = false;
    //this.addCashForm.get('amount').reset();
    //this.addCashForm.reset();
  }

  closeThankyou() {
    this.showThankyouModal = false;
    let currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  addCoin() {
    this.addCashmodal = false;
    this.addCoinmodal = true;
  }

  onCoinSubmit() {
    this.coinsubmitted = true;
    if (this.addCoinForm.invalid) {
      return;
    }
    var addCoinData = this.addCoinForm.value;
    addCoinData["userId"] = this.userId;
    if (addCoinData["amount"] > 0) {
      this.addCoinmodal = false;
      addCoinData = JSON.stringify(addCoinData, null, 4);
      this.walletpaymentService
        .addWalletPayment(addCoinData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCoinForm.value.amount * 10 * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Coins to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: "COINS",
              amount: this.addCoinForm.value.amount,
            };
            // call your backend api to verify payment signature & capture transaction
            this.walletpaymentService
              .verifyWalletpayment(verifyPaymentData)
              .subscribe((paymentdata) => {
                window.scroll(0, 0);
                this.showThankyouModal = true;
                let currentUrl = this.router.url;
                this.addCashForm.reset();
                this.addCoinForm.reset();
                // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                //   this.router.navigate([currentUrl]);
                // });
                window.location.reload();
              });
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
            console.log("Transaction cancelled.");
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }

  transferAmountToBank(id) {
    this.router.navigate(['my-wallet/wallet-redemption/'+id]);
}
getBanner() {
  let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=login";
  this.bannerService.getbannerList(query).subscribe(
    data => {
      this.loading = false;
      this.bannerList = data.data.items;
      this.totalRecords = data.data.totalCount;
      this.bannerList.forEach(element => {
        this.bannerImageList = element.banner_image;
      });
    },
    err => {
      this.errorMessage = err.error.message;
    });
}
  coinclose() {
    this.coinsubmitted = false;
    //this.addCoinForm.reset();
  }
  viewReferreList(){
    this.router.navigate(["academies-profile/academy-referrer-list"])
  }
  loadAcademyReferrerList(userId) {
    var query = "&filterByDisable=false";

    this.userService.getAcademyReferrerList(userId, query).subscribe(
        data => {
            this.loading = false;
            console.log(data)
            this.totalReferee = data.totalCount;
        },
        err => {
            this.errorMessage = err.error.message;
        });
}
copyInputValue() {
  // Select the text within the input field
  this.inputRef.nativeElement.select();

  // Copy the selected text to the clipboard
  document.execCommand('copy');

  // Deselect the text
  window.getSelection().removeAllRanges();
}
}
